import React, { useState } from "react";

interface useCustomTabsProps<T> {
  initialValue: T;
}

const useCustomTabs = <T>({ initialValue }: useCustomTabsProps<T>) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (event: React.SyntheticEvent, newValue: T) => {
    setValue(newValue);
  };
  return {
    value,
    handleChange,
  };
};

export default useCustomTabs;
